@if (savedCartsError()) {
  <ideal-error [error]="savedCartsError()"></ideal-error>
} @else {
  <div withLoadingSkeleton [isLoading]="savedCartsLoading()">
    @let carts = savedCarts();
    @if (carts.length) {
      <mat-nav-list>
        @for (cart of carts; track $index) {
          <a [routerLink]="[cart.id]">
            <mat-list-item>
              <span>
                {{ cart.name }}
              </span>
              <button mat-icon-button matListItemMeta (click)="$event.stopPropagation(); $event.preventDefault(); deleteCart(cart)">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-list-item>
          </a>
        }
      </mat-nav-list>
    } @else {
      <ideal-note>You don't have any saved carts</ideal-note>
    }
  </div>
}
